import { apiClient } from '../../../gateways/api'
import type { HoofdleidingProject } from '../types/HoofdleidingProject'

export { createProject }

const createProject = async ({
  project,
}: {
  project: Partial<HoofdleidingProject>
}): Promise<HoofdleidingProject> => {
  const { data } = await apiClient({
    url: '/rest/project',
    method: 'POST',
    data: project,
  })

  return data
}
